import styled from 'styled-components';

export const SectionEnvironmentWrapper = styled.div`
  padding: 12px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border: 1px solid #a8cbe2;
  border-radius: 8px;
  color: #161d1f;
  background-color: #f7fafb;

  svg {
    height: 16px;
    width: 16px;
    color: #283044;
  }

  p {
    text-transform: capitalize;
    > span {
      color: #4f6168;
    }
  }

  > ul > li {
    height: 44px;
    display: flex;
    gap: 8px;
    align-items: center;
    border-bottom: 1px solid #bfd8e9;

    > p {
      flex-grow: 1;
    }

    &:last-child {
      border-bottom: none;
    }
  }
`;
